import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'thousandsPipe'
})

export class ThousandsPipe implements PipeTransform {

    transform(value: string | number): string {
        if (Number(value) == 0) {
            return "0";
        } else {
            return value ? value.toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.') : null;
        }

    }

}

